import { AfterViewInit, Directive, Input } from '@angular/core';
import DotLottiePlayer from '@aarsteinmedia/dotlottie-player/light';

@Directive({ selector: '[mweDotLottiePlayerSrc]' })
export class DotlottiePlayerSrcDirective implements AfterViewInit {
  @Input() mweDotLottiePlayerSrc: string;
  @Input() playerId: string;

  async ngAfterViewInit() {
    const lottieEl = document.querySelector(`#${this.playerId}`);
    if (!lottieEl) return;
    await (lottieEl as DotLottiePlayer).load(this.mweDotLottiePlayerSrc);
  }
}
